package com.narbase.letsgo.web.views.linkshare

import com.narbase.kunafa.core.components.TextInput
import com.narbase.kunafa.core.components.TextView
import com.narbase.kunafa.core.components.View
import com.narbase.kunafa.core.components.textView
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.kunafa.core.css.padding
import com.narbase.kunafa.core.css.width
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.web.models.RideStatus
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.filters.FiltersView
import com.narbase.letsgo.web.utils.views.matchParentWidth
import sd.gov.moe.lp.admin.utils.views.filters.DropListFilter

/**
 * Filters for the Link Share logs tab, used inside a [FiltersView].
 */

open class RideFinalStatusFilter(
    onItemSelected: (RideStatus?) -> Unit,
) : DropListFilter<RideStatus?>(
    "Ride final status".localized(),
    "Final status".localized(),
    RideStatus.finalStates().toTypedArray(),
    defaultValue = null,
    valueToString = { it?.name ?: "" },
    onItemSelected = { onItemSelected(it) },
)

open class ShareTokenFilter(
    private val onValueChanged: (String?) -> Unit,
) : FiltersView.FilterType<String>() {

    private var textInput: TextInput? = null
    private var value: String? = null

    override fun View?.getView(): View = verticalLayout {
        matchParentWidth()
        theme.label(this, "Share token".localized(), isRequired = false)
        textInput = theme.textInput(this) {
            style { width = matchParent; padding = 8.px }
            element.onchange = {
                value = text.ifBlank { null }
                onValueChanged(value)
                filterParent.onFilterUpdated()
            }
        }
    }

    override fun onFilterCleared() {
        textInput?.text = ""
        value = null
        onValueChanged(null)
    }

    override fun getFilterValueAsString(): String? = value?.let { "Token: $it" }
}

open class PassengerPickerFilter(
    private val title: String,
    private val onPassengerIdSelected: (KmmLong?) -> Unit,
) : FiltersView.FilterType<Long>() {

    private var selectedName: String? = null
    private var valueLabel: TextView? = null

    override fun View?.getView(): View = verticalLayout {
        matchParentWidth()
        theme.label(this, title, isRequired = false)
        valueLabel = textView {
            text = "Any".localized()
        }
        verticalFiller(4)
        theme.mainButton(this) {
            text = "Select passenger".localized()
            onClick = {
                PassengerFilterDialog { passenger ->
                    val name = passenger.passenger.fullName
                    selectedName = name
                    valueLabel?.text = name
                    filterParent.onFilterUpdated()
                    onPassengerIdSelected(passenger.passenger.id)
                }.show()
            }
        }
    }

    override fun onFilterCleared() {
        selectedName = null
        valueLabel?.text = "Any".localized()
        onPassengerIdSelected(null)
    }

    override fun getFilterValueAsString(): String? = selectedName?.let { "$title: $it" }
}
